import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css';

const ProductDescription = ({
  description,
  onDescriptionChange,
  expanded,
  toggleSection
}) => {
  return (
    <Card
      elevation={3}
      sx={{
        mb: 3,
        borderLeft: '6px solid #4caf50',
        borderRadius: 2,
        backgroundColor: '#f9f9f9'
      }}
    >
      <CardHeader
        avatar={<DescriptionIcon sx={{ color: '#4caf50' }} />}
        title={
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
            Product Description
          </Typography>
        }
        action={
          <IconButton onClick={() => toggleSection('description')}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        sx={{
          backgroundColor: '#f0f0f5',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          py: 1.5,
          px: 2
        }}
      />
      <Divider />
      <Collapse in={expanded}>
        <CardContent sx={{ px: 3, py: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Description
          </Typography>

          <Box
            sx={{
              '& .ql-toolbar': {
                borderRadius: '8px 8px 0 0',
                backgroundColor: '#fff'
              },
              '& .ql-container': {
                borderRadius: '0 0 8px 8px',
                minHeight: '250px',
                backgroundColor: '#fff'
              },
              border: '1px solid #c8e6c9',
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            }}
          >
            <ReactQuill
              value={description}
              onChange={onDescriptionChange}
              placeholder="Enter detailed product description..."
              modules={{
                toolbar: [
                  [{ header: '1' }, { header: '2' }, { font: [] }],
                  [{ list: 'ordered' }, { list: 'bullet' }],
                  ['bold', 'italic', 'underline'],
                  [{ align: [] }],
                  ['link', 'image'],
                  ['blockquote', 'code-block']
                ]
              }}
              style={{ border: 'none' }}
            />
          </Box>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default ProductDescription;
